export {
  default,
} from '@/components/pages/banner-board/jobs';
